import { GameRouteService } from "../services/GameRouteService";
import { css } from "../helpers/webComponents";
import { CanvasComponent } from "./CanvasComponent";

/** CSS affecting the {@link KeyComponent} */
const styles: string = css`
    :host {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10; 
        pointer-events: auto;
        max-width: 100%;
        object-fit: contain;
    }

    :host {
        --cursor-active: url('/assets/cursors/cursor-key.png') 4 0, auto;
    }
    .container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    .status {
        position: absolute;
        height: 7rem;
        padding-bottom: 6rem;
        cursor: var(--cursor-active);
    }

    button {
        padding: 4rem 2rem;
        border: none;
        border-radius: 5rem;
        background-color: transparent;
        color: white;
        cursor: var(--cursor-active)
    }

    button:hover {
        background-color: transparent;
    }

    img {
        max-width: 600px;
        transition: opacity 0.3s ease;
        pointer-events: auto; // so that you don't trigger the hover on the button margin
        cursor: var(--cursor-active)
    }
`;

export class KeyComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /**
     * Create a new instance of the {@link KeyComponent}.
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.refreshStatus();
    }

    /**
     * Refresh the status of the component.
     * @private
     */
    private refreshStatus(): void {
        this.render();
    }

    /**
     * Render the component's HTML content.
     * @private
     */
    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
        <style>${styles}</style>
        <div class="container">
            <div class="status">
                <button id="key-state"></button>
            </div>
            <img src="assets/img/components/control-room.png" alt="control-room" />
        </div>
    `;

        this.attachEventListeners();
    }

    /**
    * Attach event listeners to the component's elements.
    */
    private attachEventListeners(): void {
        const shadowRoot: ShadowRoot = this.shadowRoot!;
        (shadowRoot.getElementById("key-state") as HTMLButtonElement).addEventListener("click", this.startMetro.bind(this));
    }

    private async startMetro(): Promise<void> {
        await this._gameRouteService.keyTurned();
        const canvasComponent: CanvasComponent | null = document.querySelector("game-root");

        if (canvasComponent && canvasComponent.shadowRoot) {
            const gameCanvas: HTMLElement | null = canvasComponent.shadowRoot.querySelector("game-canvas");
            if (gameCanvas) {
                void (gameCanvas as CanvasComponent).refreshGameState();
            }
        }
    }
}
